import React from 'react';
import styled, { StylesProps, cx } from '../../../lib/styles';
import Image from '../Image';
import { Author } from '../../../models/article';

import storyAuthorStyles from './StoryAuthor_styles';

type StoryAuthorSize = 's' | 'm' | 'l' | 'xl';

export interface StoryAuthorProps {
  author: Author;
  vane?: boolean;
  amp?: boolean;
  link?: boolean;
  heading?: boolean;
  size?: StoryAuthorSize;
  tagline?: boolean;
}

const StoryAuthor = ({
  tagline: showTagline,
  size = 'm',
  amp,
  link,
  heading,
  author: { title, name, avatar_48, avatar_96, tagline, link: href },
  styles,
}: StoryAuthorProps & StylesProps<typeof storyAuthorStyles>) => {
  const containerProps = link
    ? { className: styles.link, href, title: name }
    : {};

  const Name = heading ? 'h1' : 'span';
  const imagePx = size === 's' ? 40 : 60;
  const content = (
    <div className={cx('StoryAuthor', styles.author)}>
      <Image
        src={avatar_96 || avatar_48 || ''}
        aspect={[1, 1]}
        width={imagePx}
        amp={amp}
        height={imagePx}
        resizeWidth={imagePx}
        color={'white'}
        corner={'f'}
        border={'grey'}
      />

      <div className={styles.text}>
        <span className={styles.authorTitle}>{title || 'Written by'}</span>
        <Name className={cx(styles.authorName, 'StoryAuthor__name')}>
          {name}
        </Name>
        {showTagline && tagline && (
          <span className={styles.authorTagline}>{tagline}</span>
        )}
      </div>
    </div>
  );

  return link ? <a {...containerProps}>{content}</a> : <div>{content}</div>;
};

export default styled(storyAuthorStyles)(StoryAuthor);
